import * as React from 'react'
import './styles.css'
// libs
import { Link } from 'react-router-dom'
// components
import LearnMoreButton from '../../../../ui/LearnMoreButton'
// assets
import Logo from '../../../../../assets/imgs/recruting/pod-cyan.svg'

const RecruitingHeader = ({ customButtonLabel }) => (
  <header className='recruiting-header'>
    <div className='box'>
      <div className='recruiting-header-content-bg' />
      <div className='recruiting-header-content'>
        <Link className='header-logo' to='/'>
          <img src={Logo} alt='Logo' />
        </Link>

        <div className='recruiting-header-button-desktop'>
          <LearnMoreButton customLabel={customButtonLabel} />
        </div>

        <div className='recruiting-header-button-mobile'>
          <Link to='/contact'>{customButtonLabel || 'Learn More'}</Link>
        </div>
      </div>
    </div>
  </header>
)

export default RecruitingHeader
